const tosAndPapEn = {
	tos: {
		title: "Terms of Service",
		description: "Please read and accept the terms and conditions to continue.",
		checkbox: "I have read Terms of Service",
	},
	pap: {
		title: "Privacy Policy",
		description: "Please read and accept the privacy policy to continue.",
		checkbox: "Accept Privacy Policy",
	},
	button: "I have accepted Terms of Service and Privacy Policy",
	messages: {
		success: "Terms and policy accepted successfully",
		error: "Failed to accept terms and policy",
	},
};

export default tosAndPapEn;
